import React from 'react';
import { HeroSection } from './components/HeroSection';
import { FeaturesGrid } from './components/FeaturesGrid';
import { LutsShowcase } from './components/LutsShowcase';
import { SoundEffects } from './components/SoundEffects';
import { VideoShowcase } from './components/VideoShowcase';
import { CTASection } from './components/CTASection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <main className="min-h-screen bg-background text-white selection:bg-primary/30" data-id="element-0">
      {/* Subtle background glow effect */}
      <div className="fixed top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none z-0" data-id="element-1"></div>

      <div className="relative z-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <FeaturesGrid data-id="element-4" />
        <LutsShowcase data-id="element-5" />
        <VideoShowcase data-id="element-6" />
        <SoundEffects data-id="element-7" />
        <CTASection data-id="element-8" />
        <FooterSection data-id="element-9" />
      </div>
    </main>;
}